






































import {Vue, Component, Emit, Ref} from 'nuxt-property-decorator'
import {SlidePanel, FileUpload} from '@frontend/components'

@Component({
  components: {
    SlidePanel,
    FileUpload
  }
})
export default class CompanyModelContainer extends Vue {
  company?: { model_filename?: string | null; model_path?: string | null } = {}
  isNew = true

  get headers() {
    return {
      Authorization: `Bearer ${this.$login.getToken()}`
    }
  }

  get url() {
    return `${process.env.VUE_APP_API_ENDPOINT}upload/company-model`
  }

  @Ref('company-model-upload-panel')
  panel: { toggle: any; hide: any }

  setCompany(company) {
    this.company = { ...company }
    if (this.company?.model_filename) {
      this.isNew = false
    } else {
      this.isNew = true
    }
  }

  toggle() {
    this.panel.toggle()
  }

  companyModelUploaded(r) {
    const response = r[0]
    if (response) {
      this.company = {
        ...this.company,
        model_filename: response.name,
        model_path: response.url
      }
    } else {
      this.company = {
        ...this.company,
        model_filename: null,
        model_path: null
      }
    }
  }

  @Emit('update')
  onCompanyModelAccept() {
    this.panel.hide()
    return this.company
  }

  onCompanyModelCancel() {
    this.panel.hide()
  }
}
